/**
 * useInstalledMarketplaceApps Hook
 *
 * React Query hooks for fetching installed marketplace applications.
 */

import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { tenantMarketplaceService } from '../../../api/marketplace.service';
import type { ApplicationSanitized } from '../../../types/application.types';

/**
 * Extended application type with update info from marketplace
 */
export type InstalledMarketplaceApp = ApplicationSanitized & {
  updateAvailable?: boolean;
  latestVersion?: string;
};

/**
 * Hook for fetching installed marketplace applications
 * Response includes update availability info for each app
 */
export const useInstalledMarketplaceApps = (
  tenantId: string
): UseQueryResult<InstalledMarketplaceApp[], Error> => {
  return useQuery<InstalledMarketplaceApp[], Error>({
    queryKey: ['marketplace', 'installed', tenantId],
    queryFn: async () => {
      console.log('[useInstalledMarketplaceApps] Fetching installed apps for tenant:', tenantId);
      return await tenantMarketplaceService.listInstalledApps(tenantId);
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
